import {Link} from "@/components/atoms/link";
import { MediaImage } from 'components/templates/media/media--image';
import {DrupalNode} from "next-drupal";
import {Button} from "@/components/atoms/button";
import {EVENT_TEASER_IMAGE_STYLE} from "@/types/image-styles";
import {useRouter} from "next/router";
import {getEventDateLabel} from "@/lib/get-event-date-label";
import {useContext} from "react";
import {Dictionary} from "@/types/hygiena-types";
import {DictionaryContext} from "@/context/dictionary-context";


/**
 * The event teaser node.
 * @param node
 * @constructor
 */
export function EventTeaser ({node}: {
  node: DrupalNode
}): JSX.Element {
  const {locale} = useRouter();
  const dateLabel = getEventDateLabel(node, locale);
  const t = useContext<Dictionary>(DictionaryContext);

  return (
    <div className="p-8 bg-white drop-shadow-sm text-black rounded-md">
      <div className="flex gap-8 items-center max-md:flex-wrap">
        <div className="w-full md:w-auto min-w-[150px]">
          <MediaImage media={node?.field_event_image} height={150} width={150} imageStyle={EVENT_TEASER_IMAGE_STYLE}  childClass="mx-auto"/>
        </div>
        <div className="flex-grow">
          <div className="font-bold pb-2">{node?.field_event_type?.name}</div>
          <h3 className="text-primary pb-2 font-bold">
            {node?.path?.alias ? (
              <Link href={node?.path?.alias ?? "/"}>
                {node?.title}
              </Link>
            ): (
              <>{node?.title}</>
            )}
          </h3>
          {dateLabel && <div className="pb-1">{getEventDateLabel(node, locale, true)}</div>}
          {node?.field_event_location?.length ? (
            <div className="pb-1">{node.field_event_location}</div>
          ): <></>}
          {!node?.field_event_external && node?.path?.alias && (
            <div className="flex justify-end">
              <Button href={node.path.alias}
                      hover={{color: "primary"}}
                      icon="chevron-right-sm" position="right">
                {`${t?.all?.learn_more}`}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
